module.exports = "0.28.1";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 474
// module chunks = 1